import { ReactElement } from "react";
import {
	ListItem
} from "client/Components";
import styles from "./GroupOverviewListItem.module.less";
import { Thumbnail } from "./Thumbnail";

export type GroupOverviewListItemProps = {
	title: string;
	hasNewItems: boolean;
	description: string | null;
	imageUrl: string | null;
	onClick: () => void;
	trackingId: string;
};

export const GroupOverviewListItem = (props: GroupOverviewListItemProps): ReactElement => {
	const {
		title,
		hasNewItems,
		description,
		imageUrl,
		onClick,
		trackingId
	} = props;

	return (
		<ListItem
			trackingId={trackingId}
			hasStatusDot={hasNewItems}
		>
			<ListItem.Content
				onClick={onClick}
				thumbnail={(
					<div className={styles.thumbnail}>
						<Thumbnail
							imageUrl={imageUrl}
							mediaPlaceholderSize="small"
						/>
					</div>
				)}
			>
				<ListItem.Row>
					<ListItem.Title>
						{title}
					</ListItem.Title>
				</ListItem.Row>
				<div className={styles.description}>
					{description}
				</div>
			</ListItem.Content>
		</ListItem>
	);
};

GroupOverviewListItem.displayName = "GroupOverviewListItem";
